import { render } from "./RoundInput.vue?vue&type=template&id=79e0a05e"
import script from "./RoundInput.vue?vue&type=script&lang=js"
export * from "./RoundInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"RoundInput.vue"]])

export default __exports__